export default __webpack_public_path__ + "static/media/note-yellow.a79afc06.svg";